import React, { useState } from "react";
import { Card, Grid, Box, Typography, Button, Paper } from "@mui/material";

const templates = [
  {
    id: 1,
    name: "Modern Living Room",
    image: "https://via.placeholder.com/300x200.png?text=Modern+Living+Room",
    description: "A stylish and contemporary living room design.",
    useCase: "Perfect for a sleek, urban apartment.",
  },
  {
    id: 2,
    name: "Cozy Bedroom",
    image: "https://via.placeholder.com/300x200.png?text=Cozy+Bedroom",
    description: "A warm and inviting bedroom space.",
    useCase: "Ideal for creating a relaxing atmosphere.",
  },
  {
    id: 3,
    name: "Rustic Kitchen",
    image: "https://via.placeholder.com/300x200.png?text=Rustic+Kitchen",
    description: "A kitchen with a rustic, natural feel.",
    useCase: "Great for a country-style home.",
  },
  {
    id: 4,
    name: "Urban Balcony",
    image: "https://via.placeholder.com/300x200.png?text=Urban+Balcony",
    description: "A modern balcony with urban views.",
    useCase: "Perfect for outdoor city living.",
  },
  {
    id: 5,
    name: "Minimalist Office",
    image: "https://via.placeholder.com/300x200.png?text=Minimalist+Office",
    description: "A clean and minimalist office design.",
    useCase: "Ideal for a productive and clutter-free workspace.",
  },
  {
    id: 6,
    name: "Luxury Bathroom",
    image: "https://via.placeholder.com/300x200.png?text=Luxury+Bathroom",
    description: "A luxurious, spa-like bathroom design.",
    useCase: "Great for creating a high-end retreat.",
  },
];

const TemplateOption = ({ onHorizonChange }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleCardClick = (template) => {
    setSelectedTemplate(template);
    onHorizonChange(template);
  };

  return (
    <>
      <Grid container spacing={2}>
        {templates.map((template, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Card
              sx={{
                backgroundColor: "#1c1c28",
                p: 2,
                "&:hover": { backgroundColor: "#34344a", cursor: "pointer" },
              }}
              onClick={() => handleCardClick(template)}
            >
              <img
                src={template.image}
                alt={template.name}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  marginBottom: "8px",
                }}
              />
              <Typography variant="body2">{template.name}</Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Selected Template Section */}
      {selectedTemplate && (
        <Box
          sx={{
            mt: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#2c2c38",
            padding: 2,
            borderRadius: 2,
          }}
        >
          <Typography variant="h5" sx={{ color: "#fff", mb: 2 }}>
            Selected Template: {selectedTemplate.name}
          </Typography>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={6}>
              <img
                src={selectedTemplate.image}
                alt={selectedTemplate.name}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  marginBottom: "8px",
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Paper sx={{ padding: 2, backgroundColor: "#3e3e49" }}>
                <Typography variant="h6" sx={{ color: "#fff", mb: 2 }}>
                  Description:
                </Typography>
                <Typography variant="body1" sx={{ color: "#ccc" }}>
                  {selectedTemplate.description}
                </Typography>
                <Typography variant="h6" sx={{ color: "#fff", mt: 3 }}>
                  Use Case:
                </Typography>
                <Typography variant="body1" sx={{ color: "#ccc" }}>
                  {selectedTemplate.useCase}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default TemplateOption;
